import React, { useEffect, useState } from 'react';

import { updatePoints } from '../../api/user';
import { useGlobalContext } from '../../context/GlobalStore';
import { useUserContext } from '../../context/UserStore';
import { Paper, TextField } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import './modal.css'

// Animated white-red-black gradient modal box
const WhiteRedBlackModalBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  padding: '2rem',
  borderRadius: '12px',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
  backdropFilter: 'blur(10px)',
  border: '2px solid rgba(255, 255, 255, 0.3)',
  
  // White -> Red -> Black -> Red -> White gradient animation
  background: 'linear-gradient(-45deg, #ffffff, #ff4757, #000000, #ff4757, #ffffff)',
  backgroundSize: '500% 500%',
  animation: 'whiteRedBlackCycle 10s ease infinite',
  
  '@keyframes whiteRedBlackCycle': {
    '0%': {
      backgroundPosition: '0% 50%',
    },
    '25%': {
      backgroundPosition: '25% 50%',
    },
    '50%': {
      backgroundPosition: '50% 50%',
    },
    '75%': {
      backgroundPosition: '75% 50%',
    },
    '100%': {
      backgroundPosition: '100% 50%',
    }
  },
  
  // Dynamic text color based on background
  '& .MuiTypography-root': {
    fontWeight: 'bold',
    textShadow: '2px 2px 4px rgba(0,0,0,0.7), -1px -1px 2px rgba(255,255,255,0.7)',
    animation: 'textColorCycle 10s ease infinite',
  },
  
  '@keyframes textColorCycle': {
    '0%': { color: '#000000' },      // Black text on white
    '25%': { color: '#ffffff' },     // White text on red
    '50%': { color: '#ffffff' },     // White text on black
    '75%': { color: '#ffffff' },     // White text on red
    '100%': { color: '#000000' },    // Black text on white
  },
  
  // Style text fields
  '& .MuiTextField-root': {
    margin: '10px 0',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    borderRadius: '8px',
  }
}));
export const SetPointsModal = (props) => {
  const { state: globalState, action: globalActions } = useGlobalContext();
  const { state: userState, action: userActions } = useUserContext();
  const [points, setPoints] = useState(userState.points);
  const handleOpen = () => userActions.toggleSetPointModalAction();
  const handleClose = () => userActions.toggleSetPointModalAction();

  const [error, setError] = React.useState(false);

  const handleChangePoints = (event) => {
    setPoints(event.target.value);
  };

  const handleSubmit = async () => {
    const inputToNumber = Number(points);
    if (isNaN(inputToNumber)) {
      setError("Input isn't a number.");
      return false;
    }
    setError();
    await updatePoints(points);
    userActions.getUserDataAsyncAction();
    userActions.getUserEventsAsync();
    handleClose();
  };

  useEffect(() => {
    setPoints(userState.points);
  }, [userState.points]);

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '50px ridge red',
    boxShadow: 24,
    p: 4,
  };

  return (
    <div>
      <Button variant="contained" style={{ border: '20px ridge blue' }} className="button" onClick={handleOpen}>
        Set Points
      </Button>
      <Modal
        open={userState.isSetPointModalOpen || false}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <WhiteRedBlackModalBox>
          <Paper elevation={20} style={{ width: 120, height: 50, backgroundColor: 'rgba(0,0,0,0.8)', borderRadius: '8px' }}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              style={{ padding: '6px 0 0 8px', color: 'white', textShadow: 'none' }}
            >
              Set Points
            </Typography>
          </Paper>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Set the number of points.
          </Typography>
          Current Points: {userState?.points}
          <br />
          <br />
          <TextField
            error={!!error}
            id="filled-basic"
            label={error ? 'Error' : 'Points'}
            variant="filled"
            value={points}
            helperText={error}
            onChange={handleChangePoints}
            fullWidth
          />
          <Button 
            onClick={handleSubmit}
            sx={{ 
              mt: 2,
              background: 'rgba(255, 255, 255, 0.9)',
              color: 'black',
              fontWeight: 'bold',
              border: '2px solid rgba(0, 0, 0, 0.2)',
              borderRadius: '8px',
              padding: '10px 20px',
              '&:hover': {
                background: 'rgba(255, 255, 255, 1)',
                transform: 'scale(1.05)',
              }
            }}
          >
            Submit
          </Button>
        </WhiteRedBlackModalBox>
      </Modal>
    </div>
  );
};
